<template>
    <div id="event_public">
        <div class="mt-3 container  pt-5">
            <div>
                <div class="container admin-wrap">
                    <div class="row header mb-3">
                        <div class="col-lg-5 ">
                            <h3 class="text-left ">Invitation</h3>

                        </div>
                        <div class="col-lg-7">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">

                            <div class="empty-list_image"
                                 v-if="showNoRecord">
                                <div class="empty-list_msg">
                                    <strong>Invitation Invalid</strong>
                                    <span>Opps! It seem that this invitation is no longer available.</span>
                                </div>
                                <img src="../../assets/notfound.png"/>
                            </div>
                            <div class="pe-event" v-for="event in eventDetails" :key="event.ID">
                                <div class="pe-header">
                                    <div class="pe-title">
                                        <h4>
                                            {{event.EventTitle}}
                                        </h4>
                                    </div>
                                    <div class="date">
                                        <div class="pe-date" v-if="event.EventStartTime_Convert !== event.EventEndTime_Convert">
                                            <span>{{event.EventStartTime_Convert}} - {{event.EventEndTime_Convert}}</span>
                                        </div>
                                        <div class="pe-date" v-else>
                                            <span>{{event.EventStartTime_Convert}}</span>
                                        </div>
                                        <div class="pe-time">
                                            <span>{{event.EventStartTime_Convert1}} - {{event.EventEndTime_Convert1}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="pe-content">
                                    <div class="pe-content-item">
                                        <span>
                                            <i class="material-icons">email</i>
                                            {{event.EventParOtherEmail}}
                                        </span>
                                        <span>
                                            <i class="material-icons">room</i>
                                            {{event.EventLocation}}
                                        </span>
                                    </div>
                                    <div class="pe-join" v-if="event.eligibleRegistrationAction !== 'Not Eligible'">
                                        <el-button type="info" icon="el-icon-close" circle class="rejectBtn"
                                                   @click="setFalseStatus(event)"
                                                   :class="{'is-active' : event.status === 'Withdraw'}">Withdraw
                                        </el-button>
                                        <el-button type="info" icon="el-icon-check" circle
                                                   @click="setTrueStatus(event)"
                                                   :class="{'is-active' : event.status === 'Join'}">Join
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import DataSource from "../../data/datasource";
    import Cookies from "js-cookie";
    import moment from 'moment';


    export default {
        name: "EventPublicRegistration",
        created() {
            this.getEncryptedID();
            this.getPublicRegistration();
        },
        data() {
            return {
                eventID: "",
                eventDetails: [],
                showNoRecord: false,
            };
        },
        methods: {
            async init() {
                await this.getEncryptedID();
                await this.getPublicRegistration();
            },
            getEncryptedID() {
                let decode = this.$route.query.Pid;
                this.eventID = decodeURI(decode);
                console.log(this.eventID);
            },
            async getPublicRegistration() {
                try {
                    this.$vs.loading();
                    const response = await DataSource.shared.getPublicRegistrationDetails(this.eventID);
                    if (response.code === "99") {
                        console.log('99');
                    } else {
                        this.eventDetails = response.Table;
                        console.log(this.eventDetails);
                        if (!this.eventDetails||this.eventDetails&&this.eventDetails.length<1){
                            this.showNoRecord = true;
                        }
                        this.convertDateFormat();
                        this.addStatus();
                    }
                    this.$vs.loading.close();
                } catch (e) {
                    console.log(e);
                }
            },
            convertDateFormat() {
                this.eventDetails.forEach(x => {
                    x.EventStartTime_Convert1 = moment(x.EventStartTime).format("hh:mm A");
                    x.EventStartDate = moment(x.EventStartTime).format("MM/DD/YYYY");
                    x.EventEndTime_Convert1 = moment(x.EventStartTime).format("hh:mm A");
                    x.EventEndDate = moment(x.EventStartTime).format("MM/DD/YYYY");
                });
            },
            addStatus() {
                this.eventDetails.forEach(x => {
                    if (x.eligibleRegistrationAction === "Join"){
                        x.status = "Withdraw";
                    }else if(x.eligibleRegistrationAction === "Withdraw"){
                        x.status = "Join";
                    }else{
                        x.status = "";
                    }
                });
            },
            setFalseStatus(item) {
                item.status = "Withdraw";
                this.$forceUpdate();
                this.savePublicEvent(item.status);
            },
            setTrueStatus(item) {
                item.status = "Join";
                this.$forceUpdate();
                this.savePublicEvent(item.status);
            },
            async savePublicEvent(status) {
                try {
                    console.log(status)
                    const response = await DataSource.shared.savePublicRegistration(this.eventID, status);
                    if (response.code === "99") {
                        console.log('99');
                    } else if (response.code === '1') {
                        this.$notify({
                            title: 'Success',
                            message: 'Event Registered!',
                            type: 'success'
                        });
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        },
    };
</script>
<style scoped>
    .pe-title h4 {
        color: #33383c;
        margin: 0;
    }

    .pe-header {
        display: flex;
    }

    .pe-title {
        text-align: left;
    }

    .pe-header .date {
        margin-left: auto;
        text-align: right;
        font-size: 1.2em;
    }

    .pe-header .date * {
        display: block;
    }

    .pe-header small {
        color: #b7b9ba;
        font-size: 12px;
    }

    .pe-event {
        padding: 30px;
        border-top: 1px solid #edf0f4;
    }

    .pe-date {
        display: flex !important;
        margin: 0 0px 5px -4px;
        align-items: center;
    }

    .pe-date span {
        background: #edf0f4;
        color: #212529;
        font-size: 0.8em;
        padding: 3px 10px;
        border-radius: 20px;
        margin: 0;
        min-width: 100%;
        text-align: center;
    }

    .pe-time span {
        color: #212529;
        font-size: 0.8em;
        margin: 0 4px;
    }

    .pe-content-item {
        text-align: left;
    }

    .pe-content-item span {
        display: block;
        margin-bottom: 10px;
        color: #606266;
    }

    .pe-content {
        display: flex;
        padding: 10px 20px;
        align-items: center;
        background: #f5f7faa3;
        border-radius: 5px;
        margin: 20px 0;
        border: 1px solid #eee;
    }

    .pe-join {
        margin-left: auto;
    }

    .pe-content-item span i {
        background: #007bff;
        width: 30px;
        height: 30px;
        border-radius: 100%;
        top: 4px;
        line-height: 30px;
        text-align: center;
        font-size: 18px;
        color: white;
        margin-right: 10px;
    }

    #event_public .admin-wrap {
        padding: 0;
        overflow: hidden;
    }

    #event_public .admin-wrap .header {
        /*background: linear-gradient(to bottom right, #007bff, #409eff);*/
        padding: 100px 15px 0;
        margin: 0 !important;
        background: #007bff url(../../assets/event-invitationBG.png) no-repeat 106% 54%;
        background-size: auto 240px;
    }

    #event_public .admin-wrap .header h3 {
        color: white;
    }
    .empty-list_image strong {
        position: relative;
    }
</style>
<style>
    .pe-join .el-button--info {
        background: #edf0f4;
        color: #222;
        border: 0px;
        border-radius: 5px !important;
    }

    .pe-join .el-button--info.is-active {
        background: #53d575;
        color: #fff !important;
        border-color: transparent !important;
    }

    .pe-join .el-button--info.is-active span {
        color: #fff !important;
    }

    .pe-join .el-button--info span {
        color: #222;
        font-weight: normal;
        letter-spacing: 0;
    }

    .pe-join .el-button--info.is-active.rejectBtn {
        background: #f9514e;
        border-color: transparent !important;
    }
</style>